import { render, staticRenderFns } from "./DomesticLogistics.vue?vue&type=template&id=e730cb16&scoped=true&"
import script from "./DomesticLogistics.vue?vue&type=script&lang=js&"
export * from "./DomesticLogistics.vue?vue&type=script&lang=js&"
import style0 from "./DomesticLogistics.vue?vue&type=style&index=0&id=e730cb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e730cb16",
  null
  
)

export default component.exports